import React, { Component } from 'react';
import ModuleContainer from '../../../components/ModuleContainer';
import ViewHeader from '../../../components/ViewHeader';
import { FaPlus, FaEye, FaEdit, FaTrashAlt } from 'react-icons/fa';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import TableTemplate from '../../../components/TableTemplate';
import { MODE_VIEW, MODE_EDIT, SUCCESS, NOTIF_SUCCESS, NOTIF_ERROR, SECONDARY, 
    BLACK, LINK, BLUE, RED, NO, YES, DANGER, 
    SUCCESS_BUTTON, PAGINATION_NUMBER,
    VIDEO_MANAGEMENT_TITLE, ADD_VIDEO
} from '../../../../utils/constants';
import { DELETE_POPUP, DELETE_MESSAGE } from '../../../../utils/messages';
import { announcementOperations } from '../state';
import { VIEW_VIDEO_DETAILS, NEW_VIDEO_DETAILS } from '../routes';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { SideNotification } from '../../../../utils/common';
import { isNullOrUndefined } from 'util';
import Pagination from '../../../components/PaginationTemplate';
import debounce from 'lodash.debounce';

class VideoManagement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            activePage: 1,
            totalPages: 0,
            showDeleteModal: false,
            allVideoList: []
        }
        this.retrieveList = debounce(this.retrieveList.bind(this), 500);
        this.deleteRow = debounce(this.deleteRow.bind(this), 500);
    }

    componentDidMount() {
        this.retrieveList();
    }

    retrieveList = () => {
        let data = {
            "pageNumber": this.state.activePage
        }

        this.props.getAllVideos()
            .then(response => {
                if (undefined !== response) {
                    this.setState({
                        totalPages: response.data.totalPage,
                        videoList: response.data
                    })
                }
            })
    }

    toggleDelete = (row) => {
        this.setState({
            modalId: isNullOrUndefined(row) ? null : row.gameVideoId,
            showDeleteModal: !this.state.showDeleteModal
        })
    }

    viewAnnouncement = (data, type) => {
        let params = {};
        if (MODE_EDIT === type || MODE_VIEW === type) {
            params.data = data;
            params.type = type;

            this.props.history.push({
                pathname: VIEW_VIDEO_DETAILS + `/${data.gameVideoId}`,
                state: params
            })
        } else {
            this.props.history.push(NEW_VIDEO_DETAILS);
        }
    }

    deleteRow = () => {
        this.props.deleteVideo(this.state.modalId)
            .then((result) => {
                if (SUCCESS === result.status) {
                    SideNotification(NOTIF_SUCCESS, result.message);
                    this.retrieveList();
                } else {
                    SideNotification(NOTIF_ERROR, result.message);
                }
                this.toggleDelete();
            });
    }

    handlePageClick = (pageNumber) => {
        this.setState({ activePage: pageNumber, popupList: [] }, () => this.retrieveList());
    }

    handlePagePrev = () => {
        this.setState({ activePage: this.state.activePage - PAGINATION_NUMBER, popupList: [] }, () => this.retrieveList());
    }

    handlePageNext = () => {
        this.setState({ activePage: this.state.activePage + PAGINATION_NUMBER, popupList: [] }, () => this.retrieveList());
    }

    handlePageFirst = () => {
        this.setState({ activePage: PAGINATION_NUMBER, popupList: [] }, () => this.retrieveList());
    }

    handlePageLast = () => {
        this.setState({ activePage: this.state.totalPages, popupList: [] }, () => this.retrieveList());
    }

    render() {
        return (
            <ModuleContainer>
                <ViewHeader
                    title={VIDEO_MANAGEMENT_TITLE}
                    rightButtons={[
                        { variant: SUCCESS_BUTTON, label: ADD_VIDEO, icon: FaPlus, onClick: this.viewAnnouncement }
                    ]}
                />

                <TableTemplate
                    tableHeader={this.props.videoTableHeaders}
                    tableColumns={this.props.videoTableColumns}
                    tableList={this.state.videoList}
                    rowButtons={[
                        { variant: LINK, icon: FaEye, color: BLACK, onClick: this.viewAnnouncement, type: MODE_VIEW },
                        { variant: LINK, icon: FaEdit, color: BLUE, onClick: this.viewAnnouncement, type: MODE_EDIT },
                        { variant: LINK, icon: FaTrashAlt, color: RED, onClick: this.toggleDelete }
                    ]}
                />

                <Pagination
                    {...this.state}
                    handlePageClick={this.handlePageClick}
                    handlePagePrev={this.handlePagePrev}
                    handlePageNext={this.handlePageNext}
                    handlePageLast={this.handlePageLast}
                    handlePageFirst={this.handlePageFirst}
                />

                <ConfirmationModal
                    show={this.state.showDeleteModal}
                    toggleModal={this.toggleDelete}
                    title={DELETE_POPUP}
                    message={DELETE_MESSAGE}
                    modalButtons={[
                        { label: NO, onClick: this.toggleDelete, variant: SECONDARY },
                        { label: YES, onClick: this.deleteRow, variant: DANGER }
                    ]}
                />

            </ModuleContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        videoList: state.announcements.videoList,
        videoTableHeaders: state.announcements.videoTable.tableHeaders,
        videoTableColumns: state.announcements.videoTable.tableColumns
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getAllVideos: announcementOperations.getAllVideos,
        deleteVideo: announcementOperations.deleteVideo
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(VideoManagement);
